import { jsx } from "react/jsx-runtime";
import { faBell, faClock, faClone, faClipboard, faEye, faFileAlt, faFolder, faFolderOpen, faListAlt, faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft, faArrowRight, faBan, faCaretDown, faChalkboard, faCheck, faCircle, faChevronCircleLeft, faClock as faClock$1, faCloud, faCog, faCreditCard, faDownload, faPen, faEllipsisV, faExclamationCircle, faExpandArrowsAlt, faFolder as faFolder$1, faGlobe, faQuestionCircle, faInfoCircle, faLock, faLongArrowAltDown, faLongArrowAltUp, faMinusCircle, faMoneyCheckAlt, faPause, faPlay, faPlus, faPlusCircle, faFileInvoiceDollar, faQuestion, faRocket, faSearch, faShareAlt, faShieldAlt, faSquare, faStar, faCheckCircle, faSyncAlt, faTachometerAlt, faTasks, faTerminal, faTrashAlt, faUnlock, faGripHorizontal, faVirus, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash/fp.js";
import { ReactComponent as SvgAngleDoubleUpRegular } from "./icons/angle-double-up-regular.svg.js";
import { ReactComponent as SvgAngleUpRegular } from "./icons/angle-up-regular.svg.js";
import { ReactComponent as SvgArrowLeftRegular } from "./icons/arrow-left-regular.svg.js";
import { ReactComponent as SvgBarsLight } from "./icons/bars-light.svg.js";
import { ReactComponent as SvgBooksSolid } from "./icons/books-solid.svg.js";
import { ReactComponent as SvgCardMenuIcon } from "./icons/card-menu-icon.svg.js";
import { ReactComponent as SvgCloudCompute } from "./icons/cloud-compute.svg.js";
import { ReactComponent as SvgCloudUploadSolid } from "./icons/cloud-upload-solid.svg.js";
import { ReactComponent as SvgColumnGrabber } from "./icons/column_grabber.svg.js";
import { ReactComponent as SvgCopySolid } from "./icons/copy-solid.svg.js";
import { ReactComponent as SvgDownloadRegular } from "./icons/download-regular.svg.js";
import { ReactComponent as SvgExternalLinkAltRegular } from "./icons/external-link-alt-regular.svg.js";
import { ReactComponent as SvgFileExportRegular } from "./icons/file-export-regular.svg.js";
import { ReactComponent as SvgFileSearchSolid } from "./icons/file-search-solid.svg.js";
import { ReactComponent as SvgInfoCircleRegular } from "./icons/info-circle-regular.svg.js";
import { ReactComponent as SvgLeftCircleFilled } from "./icons/left-circle-filled.svg.js";
import { ReactComponent as SvgListRegular } from "./icons/list-regular.svg.js";
import { ReactComponent as SvgLoadingSpinner } from "./icons/loading-spinner.svg.js";
import { ReactComponent as SvgMenuIconFilled } from "./icons/menu-icon-filled.svg.js";
import { ReactComponent as SvgMinusCircleRed } from "./icons/minus-circle-red.svg.js";
import { ReactComponent as SvgPlusCircleFilled } from "./icons/plus-circle-filled.svg.js";
import { ReactComponent as SvgRenameIcon } from "./icons/rename-icon.svg.js";
import { ReactComponent as SvgShieldCheckSolid } from "./icons/shield-check-solid.svg.js";
import { ReactComponent as SvgSquareLight } from "./icons/square-light.svg.js";
import { ReactComponent as SvgSyncAltRegular } from "./icons/sync-alt-regular.svg.js";
import { ReactComponent as SvgTalkBubble } from "./icons/talk-bubble.svg.js";
import { ReactComponent as SvgTimesLight } from "./icons/times-light.svg.js";
import { ReactComponent as SvgTrashCircleFilled } from "./icons/trash-circle-filled.svg.js";
import { ReactComponent as SvgWarningInfo } from "./icons/warning-info.svg.js";
import { ReactComponent as SvgWdl } from "./icons/wdl.svg.js";
const fa = _.curry((shape, { size, ...props }) => jsx(FontAwesomeIcon, { ..._.merge({ icon: shape, style: { height: size, width: size } }, props) }));
const custom = _.curry((Shape, { size, ...props }) => jsx(Shape, { ..._.merge({ "aria-hidden": true, focusable: false, style: { height: size, width: size } }, props) }));
const rotate = _.curry((rotation, shape, props) => shape(_.merge({ style: { transform: `rotate(${rotation}deg)` } }, props)));
const iconLibrary = {
  "angle-down": rotate(180, custom(SvgAngleUpRegular)),
  "angle-left": rotate(-90, custom(SvgAngleUpRegular)),
  "angle-right": rotate(90, custom(SvgAngleUpRegular)),
  "angle-up": custom(SvgAngleUpRegular),
  "angle-double-left": rotate(-90, custom(SvgAngleDoubleUpRegular)),
  "angle-double-right": rotate(90, custom(SvgAngleDoubleUpRegular)),
  arrowLeft: fa(faArrowLeft),
  arrowLeftRegular: custom(SvgArrowLeftRegular),
  arrowRight: fa(faArrowRight),
  ban: fa(faBan),
  bars: custom(SvgBarsLight),
  bell: fa(faBell),
  cardMenuIcon: custom(SvgCardMenuIcon),
  caretDown: fa(faCaretDown),
  chalkboard: fa(faChalkboard),
  check: fa(faCheck),
  circle: fa(faCircle),
  "circle-chevron-left": fa(faChevronCircleLeft),
  clock: fa(faClock),
  clockSolid: fa(faClock$1),
  cloud: fa(faCloud),
  cloudBolt: custom(SvgCloudCompute),
  cog: fa(faCog),
  columnGrabber: custom(SvgColumnGrabber),
  copy: fa(faClone),
  copySolid: custom(SvgCopySolid),
  "copy-to-clipboard": fa(faClipboard),
  creditCard: fa(faCreditCard),
  download: fa(faDownload),
  downloadRegular: custom(SvgDownloadRegular),
  edit: fa(faPen),
  "ellipsis-v": fa(faEllipsisV),
  "ellipsis-v-circle": (props) => fa(faEllipsisV, { mask: faCircle, transform: "shrink-8", ...props }),
  "error-standard": fa(faExclamationCircle),
  "expand-arrows-alt": fa(faExpandArrowsAlt),
  export: custom(SvgFileExportRegular),
  eye: fa(faEye),
  fileAlt: fa(faFileAlt),
  fileSearchSolid: custom(SvgFileSearchSolid),
  folder: fa(faFolder),
  folderSolid: fa(faFolder$1),
  "folder-open": fa(faFolderOpen),
  globe: fa(faGlobe),
  help: fa(faQuestionCircle),
  "info-circle": fa(faInfoCircle),
  "info-circle-regular": custom(SvgInfoCircleRegular),
  "left-circle-filled": custom(SvgLeftCircleFilled),
  library: custom(SvgBooksSolid),
  listAlt: fa(faListAlt),
  loadingSpinner: custom(SvgLoadingSpinner),
  lock: fa(faLock),
  "long-arrow-alt-down": fa(faLongArrowAltDown),
  "long-arrow-alt-up": fa(faLongArrowAltUp),
  "menu-icon-filled": custom(SvgMenuIconFilled),
  "minus-circle": fa(faMinusCircle),
  "minus-circle-red": custom(SvgMinusCircleRed),
  "money-check-alt": fa(faMoneyCheckAlt),
  pause: fa(faPause),
  play: fa(faPlay),
  plus: fa(faPlus),
  "plus-circle": fa(faPlusCircle),
  "plus-circle-filled": custom(SvgPlusCircleFilled),
  "lighter-plus-circle": (props) => fa(faPlus, { mask: faCircle, transform: "shrink-6", ...props }),
  "pop-out": custom(SvgExternalLinkAltRegular),
  purchaseOrder: fa(faFileInvoiceDollar),
  question: fa(faQuestion),
  renameIcon: custom(SvgRenameIcon),
  rocket: fa(faRocket),
  search: fa(faSearch),
  share: fa(faShareAlt),
  shield: fa(faShieldAlt),
  shieldCheck: custom(SvgShieldCheckSolid),
  squareLight: custom(SvgSquareLight),
  squareSolid: fa(faSquare),
  star: fa(faStar),
  "success-standard": fa(faCheckCircle),
  sync: custom(SvgSyncAltRegular),
  syncAlt: fa(faSyncAlt),
  tachometer: fa(faTachometerAlt),
  tasks: fa(faTasks),
  terminal: (props) => fa(faTerminal, { mask: faSquare, transform: "shrink-8", ...props }),
  times: custom(SvgTimesLight),
  "talk-bubble": custom(SvgTalkBubble),
  "times-circle": fa(faTimesCircle),
  trash: fa(faTrashAlt),
  "trash-circle-filled": custom(SvgTrashCircleFilled),
  unlock: fa(faUnlock),
  "upload-cloud": custom(SvgCloudUploadSolid),
  "view-cards": fa(faGripHorizontal),
  "view-list": custom(SvgListRegular),
  virus: fa(faVirus),
  "warning-info": custom(SvgWarningInfo),
  "warning-standard": fa(faExclamationTriangle),
  wdl: custom(SvgWdl)
};
export {
  iconLibrary as default
};
